function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0.298584 19C0.298584 16.7909 2.08945 15 4.29858 15H30.2986V145H4.29858C2.08944 145 0.298584 143.209 0.298584 141V19Z",
  fill: "url(#paint0_linear_26_16)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M0.298584 19C0.298584 16.7909 2.08945 15 4.29858 15H30.2986V145H4.29858C2.08944 145 0.298584 143.209 0.298584 141V19Z",
  fill: "black",
  fillOpacity: 0.75
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M30.2986 9C30.2986 6.79086 32.0894 5 34.2986 5H70.2986V155H34.2986C32.0894 155 30.2986 153.209 30.2986 151V9Z",
  fill: "url(#paint1_linear_26_16)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M30.2986 9C30.2986 6.79086 32.0894 5 34.2986 5H70.2986V155H34.2986C32.0894 155 30.2986 153.209 30.2986 151V9Z",
  fill: "black",
  fillOpacity: 0.5
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 70.2986,
  width: 119.403,
  height: 160,
  rx: 4,
  fill: "url(#paint2_linear_26_16)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M189.701 5H225.701C227.911 5 229.701 6.79086 229.701 9V151C229.701 153.209 227.911 155 225.701 155H189.701V5Z",
  fill: "url(#paint3_linear_26_16)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M189.701 5H225.701C227.911 5 229.701 6.79086 229.701 9V151C229.701 153.209 227.911 155 225.701 155H189.701V5Z",
  fill: "black",
  fillOpacity: 0.5
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M229.701 15H255.701C257.911 15 259.701 16.7909 259.701 19V141C259.701 143.209 257.911 145 255.701 145H229.701V15Z",
  fill: "url(#paint4_linear_26_16)"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M229.701 15H255.701C257.911 15 259.701 16.7909 259.701 19V141C259.701 143.209 257.911 145 255.701 145H229.701V15Z",
  fill: "black",
  fillOpacity: 0.75
});

var _ref11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_26_16",
  x1: 0.298584,
  y1: 15,
  x2: 25.7433,
  y2: 24.5387,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E9E9E9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_26_16",
  x1: 30.2986,
  y1: 5,
  x2: 62.8788,
  y2: 19.1135,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#DFDFDF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_26_16",
  x1: 110.5,
  y1: 49.5,
  x2: 183.908,
  y2: 132.334,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C4C4C4"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear_26_16",
  x1: 189.701,
  y1: 5,
  x2: 222.282,
  y2: 19.1135,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#DFDFDF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear_26_16",
  x1: 229.701,
  y1: 15,
  x2: 255.146,
  y2: 24.5387,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E9E9E9"
})));

function SvgLotteryForNotRegisteredImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 160,
    viewBox: "0 0 260 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLotteryForNotRegisteredImage);
export default __webpack_public_path__ + "static/media/lotteryForNotRegisteredImage.fe83a66f3efaf8b8484cd1b2f36694cd.svg";
export { ForwardRef as ReactComponent };